import { useTranslation } from "react-i18next";
import TextCard from "./TextCard";
import ImageCard from "./ImageCard";
import DownloadCard from "./DownloadCard";
import { Row, Col } from "reactstrap";

import "../styles/StructurePageComponent.css";

import asrcertpersHistoryImage from "../resources/asrcertpers_history.jpeg";

export default function StructurePageComponent() {
  const { t } = useTranslation();

  return (
    <div className="structure-page-content">
      <TextCard
        title={t("mission_title")}
        description={t("mission_description")}
        titlePosition="left-title"
        height="100px"
      />
      <TextCard
        title={t("history_title")}
        description={t("history_description")}
        titlePosition="right-title"
        height="150px"
      />
      <ImageCard
        imageSrc={asrcertpersHistoryImage}
        altText={t("history_title")}
      />
      <Row className="download-card-grid">
        <Col>
          <DownloadCard
            title={t("rof")}
            downloadTitle={t("download_regulations_title")}
            downloadLinks={[
              {
                name: t("download_name_pdf"),
                url: "DownloadDocuments/rof/ROF_Rev.4.pdf",
              },
            ]}
          />
        </Col>
        <Col>
          <DownloadCard
            title={t("rcd")}
            downloadTitle={t("download_regulations_title")}
            downloadLinks={[
              {
                name: t("download_name_pdf"),
                url: "DownloadDocuments/rof/ROF_Rev.4_Anexa5.RCDv.15.pdf",
              },
            ]}
          />
        </Col>
      </Row>
    </div>
  );
}
